module.exports = __webpack_public_path__ + "img/IMG_1378-2.57c8cefe.png";